import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import TrainingCard from '@/components/feature/TrainingCard';
import { trainingEvents } from '@/mocks/home';
import { fetchActivityList } from '@/services/activity';
import { adaptTrainingEvents } from '@/services/adapters';
import { useRequest } from '@/hooks/useRequest';

const HOME_LIMIT = 6;

export default function ActivitiesSection() {
  // 接口失败时降级为 mock 数据
  const { data: list } = useRequest(
    () =>
      fetchActivityList({ pageIndex: 1, pageSize: HOME_LIMIT }).then((res) =>
        adaptTrainingEvents(res.list),
      ),
    { fallback: trainingEvents.slice(0, HOME_LIMIT) },
  );

  // 无数据时整段隐藏，避免出现只有标题与按钮的空板块
  if (list.length === 0) return null;

  return (
    <section id="activities" className="scroll-mt-24 w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="会议培训"
          title="名医名院赋能 · 服务能力提升"
          description="汇聚国医大师、名院名家与前沿技术，以国医大师精研班、专题研修班为载体，持续为基层医疗机构培养新时代中西医结合骨干力量。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {list.map((item) => (
            <TrainingCard key={item.id} item={item} />
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/activities"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部培训排期
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}